import { datadogRum } from '@datadog/browser-rum'

/**
 * Track errors in datadog
 * @param actionName
 * @param error
 * @param extraParams
 */
export const trackInDatadog = (actionName, error, extraParams) => {
  datadogRum.addError(
    error,
    {
      actionName: actionName,
      error: error.response || error.message,
      ...extraParams
    }
  )
}
